import {
  PostStarredProfessionalBodySchema,
  PostStarredProfessionalResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { WORKPLACE_WORKERS_ENDPOINT_URL } from "../useGetWorkerDetailsAtWorkplace";
import { getWorkplaceStarredProfessionalsUrl } from "./useGetWorkplaceStarredProfessionals";

export function usePostStarredProfessional(params: {
  workplaceId: string;
  professionalId: string;
}) {
  const { workplaceId, professionalId } = params;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/starred-professionals`,
        requestSchema: PostStarredProfessionalBodySchema,
        responseSchema: PostStarredProfessionalResponseSchema,
        data: {
          data: {
            type: "starred-professional",
            relationships: {
              worker: {
                data: {
                  type: "worker",
                  id: professionalId,
                },
              },
              workplace: {
                data: {
                  type: "workplace",
                  id: workplaceId,
                },
              },
            },
          },
        },
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [getWorkplaceStarredProfessionalsUrl(workplaceId)],
      });
      await queryClient.invalidateQueries({
        queryKey: [WORKPLACE_WORKERS_ENDPOINT_URL],
      });
    },
    meta: {
      userSuccessMessage: "Professional added to your starred list",
      logErrorMessage: APP_V2_APP_EVENTS.POST_WORKPLACE_STARRED_PROFESSIONAL_FAILURE,
      userErrorMessage:
        "There was an error adding this professional to your starred list. Please try again later.",
    },
  });
}
